"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Panel = require("./Panel.style");
var _Text = _interopRequireDefault(require("../../../../../Text"));
const announcementsTitle = 'Announcements.Title';
const FooterPanel = _ref => {
  let {
    section,
    text,
    onClose,
    children
  } = _ref;
  const isAnnouncements = text === announcementsTitle;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Panel.BgOverlay, {
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(_Panel.Panel, {
    isAnnouncements: isAnnouncements
  }, isAnnouncements && /*#__PURE__*/_react.default.createElement(_Panel.TitleWrapper, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "Body",
    variant: "BoldBlack",
    intlText: text
  }), /*#__PURE__*/_react.default.createElement(_Panel.CloseButton, {
    onClick: onClose,
    "data-test-id": "res-service-menu-".concat(section.toLowerCase(), "-close")
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    icon: "close",
    size: "lg",
    color: _uiKit.theme.colours.PRIMARY_1,
    style: {
      cursor: 'pointer'
    }
  }))), children));
};
FooterPanel.defaultProps = {
  text: null
};
var _default = exports.default = FooterPanel;